/* eslint-disable react-hooks/exhaustive-deps,import/no-unresolved */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import moment from 'moment';
import _ from 'lodash';
import InfiniteScroll from 'react-infinite-scroll-component';
import { CardSearch } from 'assets/components';
import {
  CARD_CONNECT_FINANCIAL_TRANSACTIONS,
  CARD_GALILEO_TRANSACTIONS,
  CARD_MONAVATE_TRANSACTIONS,
} from '../mutations';

import {
  cardProviders,
  CardState,
  getCardCapabilities,
  resolveDefaultTransactionStartDate,
} from '../constants';
import { useCardStatus, useUserCardProvider } from '../../../utilities/sharedHooks/user';
import Calendar from '../../../components/Calendar';
import EmptyTransactionsPage from './EmptyTransactionsPage';
import { TransactionItemPlaceholder } from '../../../components/Placeholders';
import { showAlert } from '../../../utilities/notifications';
import CardTransactionsContainer from './CardTransactionsContainer';
import { useCardTransactionBridge } from '../../../utilities/sharedHooks/card';
import TransactionsFilters from './TransactionsFilter';

const PAGE_SIZE = 10;

const Transactions = ({ isLoadingCardDetailsPage = true, ...props }) => {
  const { t: translate } = useTranslation();
  const [transactionsByDate, setTransactionsByDate] = useState([]);
  const [renderedTransactionsByDate, setRenderedTransactionsByDate] = useState([]);
  const [filterBy, setFilterBy] = useState('');
  const [currentTransactions, setCurrentTransactions] = useState([]);
  const [currentPAN, setCurrentPAN] = useState('');

  const [galileoPageNumber, setGalileoCardPageNumber] = useState(1);
  const [galileoPrevPageNumber, setGalileoPrevCardPageNumber] = useState(-1);

  const [searchObj, setSearchObj] = useState({
    term: '',
    typing: false,
    typingTimout: 0,
  });

  const { cardProvider } = useUserCardProvider();
  const [calendarVisible, setCalendarVisible] = useState(false);
  const [calendarFilter, setCalendarFilter] = useState({
    fromDate: null,
    toDate: null,
  });

  const [mastercardPageNumber, setMastercardPageNumber] = useState(0);
  const [mastercardPrevPageNumber, setMastercardPrevPageNumber] = useState(-1);

  const [isfetchMoreTransactions, setIsFetchMoreTransactions] = useState(true);

  const listInnerRef = useRef();

  const [showSearchInput, setShowSearchInput] = useState(false);
  const toggleSearchInput = () => {
    setShowSearchInput((prev) => !prev);
    props.onShowSearchInput(!showSearchInput);
  };

  const transactionMutationKey = useMemo(() => {
    let cardTransactionQuery = '';

    if (cardProvider === cardProviders.CONNECT_FINANCIAL) {
      cardTransactionQuery = CARD_CONNECT_FINANCIAL_TRANSACTIONS;
    } else if (cardProvider) {
      if (cardProvider === cardProviders.GALILEO) {
        cardTransactionQuery = CARD_GALILEO_TRANSACTIONS;
      } else {
        cardTransactionQuery = CARD_MONAVATE_TRANSACTIONS;
      }
    }

    return cardTransactionQuery;
  }, [cardProvider]);

  const { mutate: getTransactions, isLoading: isLoadingTransaction } = useMutation(
    transactionMutationKey,
    {
      onSettled: (data, error) => {
        props.setCashbackChanged(false);
        if (error) {
          showAlert({ message: error.message, type: 'danger' });
          setIsFetchMoreTransactions(false);
        } else if (!data) {
          setIsFetchMoreTransactions(false);
        } else if (data && data?.transactions?.length > 0) {
          setCurrentPAN(data?.PAN || '');
          setMastercardPrevPageNumber(mastercardPageNumber);
          setGalileoPrevCardPageNumber(galileoPageNumber);

          setCurrentTransactions([...currentTransactions, ...data.transactions]);
        } else {
          setIsFetchMoreTransactions(false);
        }
      },
    }
  );

  const { data: cardStatus } = useCardStatus();

  // Fetch Monavate transactions
  useEffect(() => {
    if (cardProvider && cardProvider === cardProviders.MONAVATE) {
      if (
        isfetchMoreTransactions &&
        mastercardPageNumber !== mastercardPrevPageNumber &&
        !isLoadingTransaction
      ) {
        getTransactions({
          page: mastercardPageNumber,
          size: PAGE_SIZE,
          searchQuery: searchObj?.term,
          from_date: calendarFilter?.fromDate,
          to_date: calendarFilter?.toDate,
          type: filterBy,
        });
      }
    } else if (cardProvider && getCardCapabilities(cardProvider).pagesTransactionsByDateRange) {
      if (
        isfetchMoreTransactions &&
        galileoPageNumber !== galileoPrevPageNumber &&
        !isLoadingTransaction
      ) {
        const startDate = calendarFilter?.fromDate
          ? calendarFilter?.fromDate?.format('YYYY-MM-DD')
          : resolveDefaultTransactionStartDate(cardProvider, moment().format('YYYY-MM-DD'));
        const endDate = calendarFilter?.toDate
          ? calendarFilter?.toDate?.format('YYYY-MM-DD')
          : moment(new Date()).format('YYYY-MM-DD');
        getTransactions({
          page: galileoPageNumber,
          size: PAGE_SIZE,
          startDate,
          endDate,
        });
      }
    }
  }, [
    cardProvider,
    galileoPrevPageNumber,
    galileoPageNumber,
    mastercardPageNumber,
    mastercardPrevPageNumber,
    isfetchMoreTransactions,
    isLoadingTransaction,
  ]);

  const resetMastercardPageNumber = () => {
    setCurrentTransactions([]);
    setMastercardPageNumber(0);
    setMastercardPrevPageNumber(-1);
    setIsFetchMoreTransactions(true);
  };

  const resetGalileoPageNumber = () => {
    setCurrentTransactions([]);
    setGalileoCardPageNumber(1);
    setGalileoPrevCardPageNumber(-1);
    setIsFetchMoreTransactions(true);
  };

  useEffect(() => {
    if (cardProvider === cardProviders.MONAVATE && props.isCashbackChanged) {
      resetMastercardPageNumber();
    } else if (
      getCardCapabilities(cardProvider).pagesTransactionsByDateRange &&
      props.isCashbackChanged
    ) {
      resetGalileoPageNumber();
    }
  }, [props.isCashbackChanged]);

  const isCardNotActive =
    !cardStatus ||
    ![CardState.ACTIVE, CardState.ACTIVATION].includes(cardStatus.cardState?.toUpperCase());
  const isCardBlocked = cardStatus && cardStatus?.cardState?.toUpperCase() === CardState.BLOCKED;

  const { transactions } = useCardTransactionBridge(currentTransactions);

  useEffect(() => {
    if (transactions && transactions.length > 0) {
      const getDate = (item) => item.formatedDate;
      const result = _(transactions).groupBy(getDate).value();
      setTransactionsByDate(result);
      setRenderedTransactionsByDate(result);
      if (transactions.length >= 2) props.setUserHasTransaction(true);
    } else {
      setTransactionsByDate([]);
      setRenderedTransactionsByDate([]);
    }
  }, [currentTransactions]);

  useEffect(() => {
    const filteredTransactionsByDate = [];
    let filteredTransactions = [];
    Object.keys(transactionsByDate).forEach((date) => {
      filteredTransactions = transactionsByDate[date];

      if (filteredTransactions && filteredTransactions.length > 0) {
        filteredTransactionsByDate[date] = filteredTransactions;
      }
    });
    setRenderedTransactionsByDate(filteredTransactionsByDate);
  }, [transactionsByDate, filterBy]);

  const fetchMoreTransactions = () => {
    if (cardProvider === cardProviders.MONAVATE) {
      setMastercardPageNumber((prev) => prev + 1);
    } else {
      // Galileo
      setGalileoCardPageNumber((prev) => prev + 1);
    }
  };

  const openCalendar = () => {
    setCalendarVisible(true);
  };

  const isReplacementRequested = props?.isReplacementRequested;

  const hasTransactions = useMemo(
    () => renderedTransactionsByDate && Object.keys(renderedTransactionsByDate).length > 0,
    [renderedTransactionsByDate]
  );

  // USED ONLY FOR Monavate TRANSACTIONS
  const onScroll = () => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;

      if (
        Math.ceil(scrollTop + clientHeight + 10) >= scrollHeight - 50 &&
        !isLoadingTransaction &&
        isfetchMoreTransactions
      ) {
        setMastercardPageNumber((prev) => prev + 1);
        setGalileoCardPageNumber((prev) => prev + 1);
      }
    }
  };

  const handleSearchOnChange = (e) => {
    if (searchObj.typingTimout) {
      clearTimeout(searchObj.typingTimout);
    }

    if (!e || !e?.target || !e?.target?.value) {
      setSearchObj({ term: '', typingTimout: 0 });
      resetMastercardPageNumber();
      resetGalileoPageNumber();
    } else {
      setSearchObj({
        term: e.target.value,
        typingTimout: setTimeout(() => {
          resetMastercardPageNumber();
          resetGalileoPageNumber();
        }, 1000),
      });
    }
  };

  const renderSearchInput = () => (
    <div className="d-flex align-items-center pe-3">
      <span className="d-flex justify-content-center align-items-center rounded-2 p-2 me-1">
        <i
          aria-label="calendar"
          role="button"
          tabIndex={-1}
          onKeyDown={() => {}}
          className="d-flex bg-lighter icon-close-other text-dark  text-f4 border rounded-3 p-1 border-disabled"
          onClick={toggleSearchInput}
        />
      </span>
      <div className="form-group m-0 p-0">
        <input
          value={searchObj?.term}
          onChange={handleSearchOnChange}
          name="search"
          className="form-control-search border-1 border-shadow text-white bg-lighter py-1 ps-5"
          placeholder={translate('search_transactions_placeholder')}
          tabIndex={0}
        />
        <span className="icon-search icon-search-other text-shadow" />
      </div>
    </div>
  );

  const renderTransactionGroup = () =>
    Object.keys(renderedTransactionsByDate).map((date) => (
      <CardTransactionsContainer
        key={date}
        data={renderedTransactionsByDate[date]}
        PAN={currentPAN}
        date={date}
        showDetails={props.showDetails}
        setDetails={props.setDetails}
      />
    ));

  const renderListComponent = () => {
    if (cardProvider && cardProvider === cardProviders.MONAVATE) {
      return (
        <>
          {renderTransactionGroup()}
          {isLoadingTransaction && <TransactionItemPlaceholder />}
        </>
      );
    }
    return (
      <InfiniteScroll
        dataLength={Object.keys(transactionsByDate).length}
        next={fetchMoreTransactions}
        scrollableTarget="scrollableDiv"
        hasMore={isLoadingTransaction}
        className="hide-scroll card-infinite-scroll"
        loader={<TransactionItemPlaceholder />}>
        {renderTransactionGroup()}
      </InfiniteScroll>
    );
  };

  const isLoading =
    isLoadingCardDetailsPage || (isLoadingTransaction && currentTransactions.length === 0);

  return (
    <div>
      {/* Card search for Browser layout */}
      <CardSearch
        onChangeSearchTerm={handleSearchOnChange}
        searchObj={searchObj}
        openCardSettingModal={props.openCardSettingModal}
        handleKeyDown={openCalendar}
        cardProvider={cardProvider}
        setFilterBy={(filter) => {
          resetMastercardPageNumber();
          resetGalileoPageNumber();
          setFilterBy(filter);
        }}
        filterBy={filterBy}
        calenderSearch={calendarFilter}
      />
      {/* {!isReplacementRequested && */}
      {/*  isCardBlocked && */}
      {/*  cardProvider && */}
      {/*  cardProvider === cardProviders.GALILEO && ( */}
      {/*    <div className=" d-flex flex-column align-items-center mobile-border-top-rounded"> */}
      {/*      <img */}
      {/*        style={{ */}
      {/*          width: '30%', */}
      {/*          height: 'auto', */}
      {/*          marginTop: '8rem', */}
      {/*          resize: 'contain', */}
      {/*          alignSelf: 'center', */}
      {/*        }} */}
      {/*        src={dynamicAssets('./assets/images/replacement.png')} */}
      {/*        alt="warning" */}
      {/*      /> */}
      {/*      <p className="text-white text-f5 mb-3 mt-5">{translate('order_card_info_1')}</p> */}
      {/*      <p className="text-shadow text-f6">{translate('order_card_info_2')}</p> */}
      {/*      <button */}
      {/*        type="button" */}
      {/*        onClick={props.openCardReportModal} */}
      {/*        className="btn btn-primary btn-sm rounded-4 py-2 px-3 mt-4"> */}
      {/*        {translate('order_replacement_card')} */}
      {/*      </button> */}
      {/*    </div> */}
      {/*  )} */}
      {((isCardBlocked && isReplacementRequested && cardProvider === cardProviders.GALILEO) ||
        (!isCardBlocked && cardProvider === cardProviders.GALILEO) ||
        cardProvider !== cardProviders.GALILEO) && (
        <>
          {/* transaction filter for mobile layout */}
          <div className="d-block d-md-none">
            <TransactionsFilters
              setFilterBy={(filter) => {
                resetMastercardPageNumber();
                resetGalileoPageNumber();
                setFilterBy(filter);
              }}
              toggleSearchInput={toggleSearchInput}
              renderSearchInput={renderSearchInput}
              showSearchInput={showSearchInput}
              openCalendar={openCalendar}
              filterBy={filterBy}
              calendarSearch={calendarFilter}
            />
          </div>
          <div
            className="card-transactions-list"
            ref={listInnerRef}
            onScroll={onScroll}
            id="scrollableDiv">
            {isLoading && (
              <div className="d-flex flex-column gap-3">
                <TransactionItemPlaceholder />
                <TransactionItemPlaceholder />
                <TransactionItemPlaceholder />
                <TransactionItemPlaceholder />
              </div>
            )}
            {!isLoading && hasTransactions && renderListComponent()}

            {!isLoading && !hasTransactions && (
              <EmptyTransactionsPage
                emptySearchResult={
                  !!searchObj?.term ||
                  !!calendarFilter?.fromDate ||
                  !!calendarFilter?.toDate ||
                  !!filterBy
                }
                isDisabled={isCardNotActive}
              />
            )}
          </div>
        </>
      )}

      <Calendar
        onHide={() => setCalendarVisible(false)}
        isVisible={calendarVisible}
        onSubmit={(form) => {
          resetMastercardPageNumber();
          resetGalileoPageNumber();
          setCalendarFilter(form);
        }}
        clearOldData={() => setCurrentTransactions([])}
      />
    </div>
  );
};

export default Transactions;

Transactions.propTypes = {
  showDetails: PropTypes.func.isRequired,
  setDetails: PropTypes.func.isRequired,
  openCardSettingModal: PropTypes.func.isRequired,
  onShowSearchInput: PropTypes.func.isRequired,
  isReplacementRequested: PropTypes.bool.isRequired,
  isCashbackChanged: PropTypes.bool.isRequired,
  setCashbackChanged: PropTypes.func.isRequired,
  isLoadingCardDetailsPage: PropTypes.bool,
  setUserHasTransaction: PropTypes.func.isRequired,
};
